module.exports = __webpack_public_path__ + "static/media/panda-mix.c2c708dd.png";